import styled from 'styled-components'
import { colorTheme } from '../../../../../../style/theme/colorTheme'
import { theme } from '../../../../../../style/theme'

export const InvoiceSheetContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.25em;
	color: ${colorTheme.invoices.modal.invoiceData.text};
	font-family: ${theme.fontRoboto};
	text-align: left;

	&.mobile {
		padding: 0 0.63em;
	}

	&.print.print,
	&.print.print * {
		font-family: ${theme.fontForPrint};
	}
`
InvoiceSheetContent.displayName = 'InvoiceSheetContent'

export const InvoiceSheetRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 1.25em;

	&.mobile {
		flex-direction: column;
		gap: 0.63em;
	}
`
InvoiceSheetRow.displayName = 'InvoiceSheetRow'

export const InvoiceSheetTextBlock = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.35em;
	font-size: 1.25em;

	&.end {
		align-items: flex-end;
		text-align: right;
	}

	&.mobile.end {
		align-items: flex-start;
		text-align: left;
	}
`
InvoiceSheetTextBlock.displayName = 'InvoiceSheetTextBlock'

export const InvoiceSheetLabel = styled.span`
	font-family: ${theme.fontRobotoBold};
	font-weight: 700;
`
InvoiceSheetLabel.displayName = 'InvoiceSheetLabel'

export const InvoiceSheetTitle = styled.div`
	padding-bottom: 0.31em;
	font-family: ${theme.fontRobotoMedium};
	font-size: 2em;
	font-weight: 600;
	text-align: center;
	text-transform: uppercase;
`
InvoiceSheetTitle.displayName = 'InvoiceSheetTitle'

export const InvoiceSheetTotals = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 0.5em;
	padding: 0.5em 0;
	font-size: 1.25em;
	text-align: right;
`
InvoiceSheetTotals.displayName = 'InvoiceSheetTotals'

export const InvoiceSheetTotalGross = styled.div`
	font-family: ${theme.fontRobotoMedium};
	font-weight: 600;
`
InvoiceSheetTotalGross.displayName = 'InvoiceSheetTotalGross'

export const InvoiceSheetTotalLines = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 0.25em;
`
InvoiceSheetTotalLines.displayName = 'InvoiceSheetTotalLines'

export const InvoiceSheetParagraph = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.25em;
	font-size: 1.25em;
`
InvoiceSheetParagraph.displayName = 'InvoiceSheetParagraph'

export const InvoiceSheetFooter = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 1.25em;
	text-align: center;
`
InvoiceSheetFooter.displayName = 'InvoiceSheetFooter'
